import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListaContratosExpo24 from '../../../components/contratos/listar/expomacuco';


function ListaContratosExpo24Screen() {
    return (
        <Fragment>
            <Head titulo="Contratos Firmados para a Expo Macuco 2024" />
            <Header />
            <Container>
                <ListaContratosExpo24 />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListaContratosExpo24Screen;